module.exports = __webpack_public_path__ + "img/mindful_days_3--active.31c0be64.svg";